module.exports = __webpack_public_path__ + "img/logo_outline.9a8e6fcc.svg";